import { Helmet } from 'react-helmet'
import FeedbackUIDesign from './FeedbackUIDesign'

const Wrapper = () => (
  <>
    <Helmet>
      <meta charSet='utf-8' />
      <title>Feedback UI Design</title>
    </Helmet>
    <FeedbackUIDesign />
  </>
)
export default Wrapper
